import { Component, ReactNode } from 'react';
import { useNavigate } from 'react-router';
import Header from './Header';
import Sidebar from './Sidebar';

export default function ProtectedRoute(props: any): ReactNode {
  return <HomeComp navigate={useNavigate()} {...props} />;
}

class HomeComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
    }>,
  ) {
    super(props);
  }

  render(): ReactNode {
    return (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
            ></Sidebar>
          </div>
        </div>
      </div>
    );
  }
}
